<ws-ace-card header="Member of the following User Group(s)">
    <ng-container card-body>
        @if (hasUsersViewOrEdit) {
            <ul class="list-group"
                style="max-height: 180px; overflow-y: auto; border-top: none;">
                @for (group of assignedGroups | sortBy: 'asc': 'name' | filter: nonDeletedFilter; track group.groupID) {
                    <li class="list-group-item px-3 py-1">
                        <div class="d-flex align-items-center justify-content-between">
                            <a anchor-route
                               [sref]="{ target: 'userGroupDetail', options: { userGroupId: group.groupID }}"
                               target="_blank"
                               class="ace-btn btn-link">
                                {{ group.name }}
                            </a>
                            @if (hasUsersEdit && canEdit) {
                                <button class="ace-btn has-icon btn-primary btn-danger m-0"
                                        (click)="deleteUserGroup(group)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            }
                        </div>
                    </li>
                }
            </ul>
        }
        @else {
            <ul class="list-group"
                style="max-height: 180px; overflow-y: auto; border-top: none;">
                @for (group of assignedGroups | sortBy: 'asc': 'name' | filter: nonDeletedFilter; track group.groupID) {
                    <li class="list-group-item">
                        {{ group.name }}
                    </li>
                }
            </ul>
        }
        @if (hasUsersEdit && canEdit) {
            <div>
                @if (!userGroupToAdd) {
                    <button type="button"
                            class="ace-btn btn-sm btn-primary btn-success"
                            (click)="selectUserGroupToAdd()"
                            [disabled]="assignedGroups.length === availableGroups.length">Add User Group
                    </button>
                }
                @else {
                    <div class="d-flex align-items-center my-2">
                        <ws-select style="width:auto; display: inline-block;"
                                   [(ngModel)]="userGroupToAdd"
                                   labelProperty="name"
                                   [returnEntireOption]="true"
                                   [options]="availableGroups | sortBy: 'asc': 'name' | filter: assignedUserGroups">
                        </ws-select>
                        <div class="ms-2">
                            <button type="button"
                                    class="ace-btn has-icon btn-primary btn-success m-1"
                                    (click)="addUserGroup()"
                                    [disabled]="!userGroupToAdd.name">
                                <i class="fa fa-save"></i>
                            </button>
                            <button type="button"
                                    class="ace-btn has-icon btn-primary btn-danger m-1"
                                    (click)="cancelAddUserGroup()">
                                <i class="fa fa-close"></i>
                            </button>
                        </div>
                    </div>
                }
            </div>
        }
    </ng-container>
</ws-ace-card>

